<template>
  <div class="container">
    <div class="row">
      <div class="col-md-4 offset-md-4">
        <header class="mt-4 mb-4">
          <h1><strong class="courier">signIn()</strong></h1>
          <em class="monaco">ssSSttt~</em>
        </header>

        <form @submit.prevent="signIn">
          <div class="form-group">
            <input type="text" v-model="email" placeholder="email" class="form-control" autofocus autocomplete="off">
          </div>
          <div class="form-group">
            <input type="password" v-model="pass" placeholder="pass" class="form-control">
          </div>
          <button class="btn btn-green text-white">Sign in</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      email: "",
      pass: "",
      user: this.$supabase.auth.user()
    }
  },
  mounted() {
    this.cekAuth()
  },
  methods: {
    cekAuth() {
      if (this.user) {
        this.$router.push('/score')
      }
    },
    async signIn() {
      const { user, session, error } = await this.$supabase.auth.signIn({
        email: this.email,
        password: this.pass,
      })
      this.$router.push('/score')
    },
  },
};
</script>

<style scoped></style>
